import type { MatchConfig } from './types';

/**
 * The one rules constant. Board size, move economy, and scoring all live here.
 * `createMatch` copies these fields and may override them (a 9×9 test, a shorter
 * duel) without editing this object.
 */
export const GAME_CONFIG = {
  boardW: 8,
  boardH: 8,
  movesPerTurn: 5,
  /**
   * No per-turn cap. Each resolution with a straight run of 4+ refunds one
   * move, and a bonus move can earn another. One resolution still refunds
   * once. 0 turns bonuses off. A finite number is a test cap.
   */
  maxBonusMovesPerTurn: Number.POSITIVE_INFINITY,
  turnsPerPlayer: 4,
  /**
   * One charge per cleared tile of a critter's color. 60 is about one full
   * meter per player in a Pip-versus-Bramble duel (see the seeded sim test).
   */
  meterMax: 60,
  meterPerTile: 1,
  pointsPerTile: 10,
  /** One clock for the whole turn. Bonus moves do not refill it. It pauses while the board resolves. */
  turnSeconds: 30,
} as const satisfies MatchConfig;

/** Safety stop so a pathological cascade cannot loop forever. */
export const MAX_CASCADES = 24;
